import "./BackWebsite.scss";

export const BackWebsite = () => {
  return (
    <a href="https://www.shadybattlegrounds.xyz/" target="_blank" className="BackWebsite">
      <div>Back to the website</div>
    </a>
  );
};
export default BackWebsite;
